import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;

	.search-components {
		position: relative;
		max-width: 440px;
		margin: 0 auto;

		.reset {
			position: absolute;
			top: 6px;
			right: 10px;
			color: inherit;
			cursor: pointer;
			color: gray;
		}

		input {
			padding-right: 20px;
			width: 100%;
			position: relative;
			background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.34938 1.60176C7.21356 -0.533921 3.73735 -0.533921 1.60152 1.60176C-0.53384 3.73791 -0.53384 7.21343 1.60152 9.34958C3.50353 11.251 6.46581 11.4547 8.60025 9.96996C8.64516 10.1825 8.74795 10.3852 8.91324 10.5505L12.0237 13.6608C12.477 14.1131 13.2094 14.1131 13.6604 13.6608C14.1132 13.208 14.1132 12.4756 13.6604 12.0242L10.5499 8.913C10.3856 8.7491 10.1823 8.64586 9.96981 8.60095C11.4556 6.46619 11.2519 3.50457 9.34938 1.60176ZM8.36736 8.36761C6.77278 9.96209 4.17766 9.96209 2.58355 8.36761C0.989897 6.77314 0.989897 4.17866 2.58355 2.58419C4.17766 0.990178 6.77278 0.990178 8.36736 2.58419C9.96194 4.17866 9.96194 6.77314 8.36736 8.36761Z' fill='%23B4B4B4'/%3E%3C/svg%3E%0A");
			background-position: 13px 45%;
			background-repeat: no-repeat;
			width: 100%;
		}
	}

	.platforms-container {
		margin-top: 50px;
		display: grid;

		grid-gap: 50px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		grid-auto-rows: minmax(auto, 150px);

		&:has(.no-items) {
			display: flex;
			align-items: center;
		}

		.no-items {
			min-width: 100%;
			display: flex;
			flex-direction: column;
			gap: 30px;
			align-items: center;
			margin: 0 auto;

			p {
				font-size: 16px;
				padding-left: 20px;
			}

			img {
				max-width: 200px;
			}
		}

		.platform-card {
			background-color: ${CSSVars.gray100};
			display: flex;
			justify-content: center;
			padding: 50px;
			border-radius: 10px;
			transition: 0.2s;
			border: 1px solid ${CSSVars.gray200};

			&:hover {
				border: 1px solid ${CSSVars.gray300};
			}

			.img-wrapper {
				img {
					max-width: 100%;
					height: 100%;
					object-fit: contain;
					position: relative !important;
				}
			}
		}
	}
`;
